import React from 'react';
import styled from 'styled-components';
import { LinkButton } from '../components/form';
import { PageContainer } from '../components/PageContainer';
import { PrimaryFont } from '../components/styles';
import { useIsMobile } from '../hooks/responsive';
import { EXTERNAL_LINKS } from '../utils/links';
import { THEME_COLORS } from '../utils/theme';
import { TagLine } from './PageHome';
import hackIcon from '../assets/hack-icon.svg';
import mentorIcon from '../assets/mentor-icon.svg';

const Content = styled.div`
  box-sizing: border-box;
`;

const HeaderLine = styled(PrimaryFont)`
  display: block;
  margin-bottom: 20px;

  color: ${THEME_COLORS.textBlue};
  font-size: 26px;
  font-weight: 700;
`;

const Section = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-flow: ${({ isMobile }) => (isMobile ? 'column' : 'row')} nowrap;

  justify-content: space-between;
  align-items: center;

  margin: ${({ isMobile }) => (isMobile ? 80 : 40)}px auto;
`;

const DescriptionContainer = styled.div<{ isMobile: boolean }>`
  width: 100%;

  margin-left: ${({ isMobile }) => (isMobile ? 20 : 150)}px;
`;

const TagImage = styled.img<{ isMobile: boolean }>`
  width: ${({ isMobile }) => (isMobile ? 200 : 250)}px;
  min-width: ${({ isMobile }) => (isMobile ? 200 : 250)}px;
  height: ${({ isMobile }) => (isMobile ? 200 : 250)}px;
  min-height: ${({ isMobile }) => (isMobile ? 200 : 250)}px;
`;

const TextDetail = styled(PrimaryFont)``;

export const PageAttend: React.FC = () => {
  const { isMobile } = useIsMobile();

  return (
    <PageContainer>
      <Content>
        <TagLine style={{ marginBottom: '15px' }}>Get a piece of the action!</TagLine>
        <HeaderLine>I want to...</HeaderLine>
        <Section isMobile={isMobile}>
          <TagImage src={hackIcon} isMobile={isMobile} />
          <DescriptionContainer isMobile={isMobile}>
            <HeaderLine>Hack</HeaderLine>
            <TextDetail>
              Whether you're new to the hackathon space or are a seasoned participant, join us at DubHacks '21 to build
              the PROJECT OF YOUR DREAMS. Experience 24 hours full of educational workshops, fun activities, and cool
              swag!
              <br />
              <br />
              You complete us! Claim your piece of the puzzle!
            </TextDetail>
            <br />
            <br />
            <br />
            <LinkButton href={EXTERNAL_LINKS.APPLY_FORM} target="_blank" rel="noopener noreferrer">
              Apply!
            </LinkButton>
          </DescriptionContainer>
        </Section>
        <Section isMobile={isMobile}>
          <TagImage src={mentorIcon} isMobile={isMobile} />
          <DescriptionContainer isMobile={isMobile}>
            <HeaderLine>Mentor</HeaderLine>
            <TextDetail>
              As a mentor, you'll guide and empower our hackers by helping them piece together their solutions. Share
              your experience and lend your expertise to support exploration and growth.
              <br />
              <br />
              You'll have a piece of our heart &lt;3 Claim your piece of the puzzle!
            </TextDetail>
            <br />
            <br />
            <br />
            <LinkButton href={EXTERNAL_LINKS.MENTOR_FORM} target="_blank" rel="noopener noreferrer">
              Sign Up!
            </LinkButton>
          </DescriptionContainer>
        </Section>
      </Content>
    </PageContainer>
  );
};
